import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Checkbox } from "@mui/material";
import AppLoading from "verticales/AppLoading.tsx";
import MDButton from "components/MDButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import TableMaestros from "../../../verticales/TableMaestrosInformes.tsx";
import fetchData from "verticales/FetchData";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

const ViewClientes = ({ data }) => {
  const [loadingState, setLoadingState] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarContent, setSnackbarContent] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("info");

  useEffect(() => {
    setTableData(data);
    setTimeout(() => {
      setLoadingState(false);
    }, 5000);
  }, [data]);

  const handleCheckboxChange = async (dataRow, checked) => {
    const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
    const context = "ec2-aws";
    const instance = {
      cuenta: dataRow.cuenta,
      instanceId: dataRow.instance_id,
      producto: dataRow.producto_serialized,
    };

    const params = { action: "extraccion", object: instance };
    console.log(`Row ${dataRow.instance_id} is ${checked ? "selected" : "deselected"}`);
    try {
      const sendData = await fetchData(url, context, params);
      console.log(sendData);
      setSnackbarContent(`Extraccion enviada para la instancia ${dataRow.instance_id}`);
      setSnackbarColor("success");
    } catch (error) {
      console.error("Error al enviar datos:", error);
      setSnackbarContent(`Error al enviar comando: ${error.message}`);
      setSnackbarColor("error");
    }

    setOpenSnackbar(true);
  };
  /* eslint-disable react/prop-types */
  const columns = useMemo(
    () => [
      {
        accessorKey: "checkbox",
        header: "Seleccionar",
        size: 50,
        Cell: ({ row }) => (
          <Checkbox
            checked={row.original.selection}
            onChange={(e) => handleCheckboxChange(row.original, e.target.checked)}
          />
        ),
      },
      { accessorKey: "cuenta", header: "Cuenta", size: 150 },
      { accessorKey: "instance_id", header: "Instance Id", size: 200 },
      { accessorKey: "instance_name", header: "Instance Name", size: 150 },
      { accessorKey: "ip_privada", header: "Ip Privada", size: 200 },
      { accessorKey: "ip_publica", header: "Ip Publica", size: 200 },
      { accessorKey: "producto_serialized", header: "Producto", size: 200 },
    ],
    []
  );
  /* eslint-enable react/prop-types */
  // Manejar la exportación de datos
  const handleExportData = () => {
    if (tableData.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }
    alert("Exportando datos...");
  };

  return (
    <DashboardLayout>
      <Box sx={{ marginTop: "1px" }}>
        {loadingState ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              width: "100vh",
              position: "absolute",
              top: 0,
              left: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <AppLoading titleCustom={"extraccion faltantes"} />
          </Box>
        ) : (
          <TableMaestros
            height="auto"
            arrayColumns={columns}
            data={tableData}
            enableGrouping
            enableStickyHeader
            enableColumnResizing
            muiTableContainerProps={{
              sx: {
                maxHeight: "calc(100vh - 400px)",
                minHeight: "200px",
                overflowY: "auto",
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
              },
            }}
            muiTableBodyCellProps={{
              sx: {
                borderRight: "1px solid #e0e0e0",
                fontSize: 14,
                padding: "0.5rem",
                wordBreak: "break-word",
              },
            }}
            muiTableHeadCellProps={{
              sx: (theme) => ({
                backgroundColor: theme.palette.mode === "light" ? "#f5f5f5" : "#303030",
                fontSize: 14,
                fontWeight: "bold",
                textAlign: "center",
              }),
            }}
            renderTopToolbarCustomActions={() => (
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  padding: "4px",
                  justifyContent: "space-between",
                }}
              >
                <MDButton
                  onClick={handleExportData}
                  startIcon={<FileDownloadIcon />}
                  sx={{ fontSize: 12, fontWeight: "normal" }}
                >
                  Exportar Datos
                </MDButton>
              </Box>
            )}
            initialState={{
              density: "compact",
              pagination: { pageIndex: 0, pageSize: 50 },
            }}
          />
        )}
      </Box>
      <MDSnackbar
        open={openSnackbar}
        color={snackbarColor}
        icon={snackbarColor === "success"}
        title="Estado de la Instancia"
        content={snackbarContent}
        onClose={() => setOpenSnackbar(false)}
        close={() => setOpenSnackbar(false)}
      />
    </DashboardLayout>
  );
};

// Validación de las props con PropTypes
ViewClientes.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      cuenta: PropTypes.string.isRequired,
      instance_id: PropTypes.string.isRequired,
      instance_name: PropTypes.string.isRequired,
      ip_privada: PropTypes.string.isRequired,
      ip_publica: PropTypes.string.isRequired,
      producto_serialized: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
};

export default ViewClientes;
